import { GlBadge, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { isUserBusy } from '~/set_status_modal/utils';
export default {
    name: 'UserNameWithStatus',
    components: {
        GlBadge,
        GlSprintf
    },
    props: {
        name: {
            type: String,
            required: true
        },
        containerClasses: {
            type: String,
            required: false,
            default: ''
        },
        availability: {
            type: String,
            required: false,
            default: ''
        },
        pronouns: {
            type: String,
            required: false,
            default: ''
        },
        compositeIdentityEnforced: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        hasPronouns () {
            return this.pronouns !== null && this.pronouns.trim() !== '';
        },
        isBusy () {
            return isUserBusy(this.availability);
        },
        isAgent () {
            return this.compositeIdentityEnforced;
        }
    }
};
